import { ACTIVE, INACTIVE } from 'AccountsApp/ts/constants/integrations.constants';
import { FidelityIntegrationService } from 'IntegrationsApp/ts/services/fidelity-integration.service';
import { FidelityIntegrationActivateModalComponent } from '../fidelity-integration-activate-modal/fidelity-integration-activate-modal.component';
import { ConfirmModalComponent } from 'Angular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/fidelity-integration.service";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i3 from "../integration-status-indicator/integration-status-indicator.component";
import * as i4 from "../fidelity-integration-activate-modal/fidelity-integration-activate-modal.component";
const _c0 = ["fidelityDeactivateModalComponent"];
const _c1 = ["ycn-fidelity-integration-list-item", ""];
export class FidelityIntegrationListItemComponent {
    constructor(fidelityIntegrationService) {
        this.fidelityIntegrationService = fidelityIntegrationService;
        this.status = INACTIVE;
        this.errorMessage = '';
        this.integrationData = null;
    }
    ngOnInit() {
        this.updateStatus();
    }
    updateStatus() {
        this.fidelityIntegrationService.getFidelityIntegrationStatus().subscribe({
            next: (data) => {
                this.integrationData = data;
                this.status = data.isActive ? ACTIVE : INACTIVE;
            },
            error: () => { },
        });
    }
    activateToggle() {
        if (this.status === ACTIVE) {
            this.fidelityDeactivateModalComponent.openModal();
        }
        else {
            this.status = ACTIVE;
            this.fidelityActivateModalComponent.openModal(this.integrationData?.headers || []);
        }
    }
    deactivateHandler(confirmed) {
        if (confirmed) {
            this.fidelityIntegrationService.deactivateFidelityIntegration().subscribe({
                next: () => {
                    this.status = INACTIVE;
                },
            });
        }
    }
}
FidelityIntegrationListItemComponent.ɵfac = function FidelityIntegrationListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FidelityIntegrationListItemComponent)(i0.ɵɵdirectiveInject(i1.FidelityIntegrationService)); };
FidelityIntegrationListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FidelityIntegrationListItemComponent, selectors: [["tr", "ycn-fidelity-integration-list-item", ""]], viewQuery: function FidelityIntegrationListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FidelityIntegrationActivateModalComponent, 5);
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fidelityActivateModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fidelityDeactivateModalComponent = _t.first);
    } }, standalone: false, attrs: _c1, decls: 16, vars: 5, consts: [["fidelityDeactivateModalComponent", ""], [1, "table-logo"], [2, "width", "42px", "height", "42px", "margin-right", "16px"], [1, "text-bold"], [3, "status"], [1, "text-right"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [3, "closeModalHandler"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"]], template: function FidelityIntegrationListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "td")(1, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, "Fidelity");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6, "Portfolio Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "td");
        i0.ɵɵelement(8, "ycn-integration-status-indicator", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "td", 5)(10, "label", 6)(11, "input", 7);
        i0.ɵɵlistener("change", function FidelityIntegrationListItemComponent_Template_input_change_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateToggle()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "span", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-fidelity-integration-activate-modal", 9);
        i0.ɵɵlistener("closeModalHandler", function FidelityIntegrationListItemComponent_Template_ycn_fidelity_integration_activate_modal_closeModalHandler_13_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updateStatus()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "ycn-confirm-modal", 10, 0);
        i0.ɵɵlistener("confirmHandler", function FidelityIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_14_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.deactivateHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("status", ctx.status);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.status === "active");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("confirmButtonText", "Deactivate")("confirmHeader", "Deactivate Fidelity Integration")("confirmText", "Are you sure you would like to deactivate your integration with Fidelity? You will not be able to use this integration unless you reactivate it.");
    } }, dependencies: [i2.ConfirmModalComponent, i3.IntegrationStatusIndicatorComponent, i4.FidelityIntegrationActivateModalComponent], encapsulation: 2 });
